<template>
  <section id="uploadImageComponent">
    <v-dialog v-model="activeDialog" persistent max-width="500">
      <ValidationObserver ref="UploadUserAvatar" v-slot="{ passes, reset }">
        <v-card>
          <v-progress-linear
            v-if="loadingUploadPhoto"
            indeterminate
            rounded
            height="6"
            color="info"
          ></v-progress-linear>

          <v-card-title class="headline primary--text">
            Cargar foto de perfil
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text>
            <v-expand-transition>
              <v-row v-if="objectUrl">
                <v-col cols="12" md="6" class="text-center">
                  <div class="overline">Original</div>

                  <v-card outlined>
                    <img width="100%" ref="source" :src="objectUrl" alt="image sourse" />
                  </v-card>

                  <div class="d-flex justify-center">
                    <v-btn icon small @click="resetCropper">
                      <v-icon small>mdi-aspect-ratio</v-icon>
                    </v-btn>
                    <v-btn icon small @click="rotateLeft">
                      <v-icon small>mdi-rotate-left</v-icon>
                    </v-btn>
                    <v-btn icon small @click="rotateRight">
                      <v-icon small>mdi-rotate-right</v-icon>
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="12" md="6" class="text-center">
                  <div class="overline">Preview</div>

                  <v-card outlined>
                    <img width="100%" :src="previewCropped" alt="Image preview" />
                  </v-card>
                </v-col>
              </v-row>
            </v-expand-transition>

            <v-expand-transition>
              <v-row v-if="objectUrl === null">
                <v-col>
                  <v-img
                    contain
                    max-width="50%"
                    class="mx-auto"
                    :src="require('@/assets/illustrations/profile_photo.svg')"
                    alt="Selfie illustration"
                  ></v-img>
                </v-col>
              </v-row>
            </v-expand-transition>

            <ValidationProvider rules="ext:png,jpg,jpeg|size:2000|required" name="foto de perfil" v-slot="{ errors }">
              <v-file-input
                filled
                rounded
                class="rounded-small"
                v-model="selectedFile"
                accept="image/png, image/jpeg"
                label="Seleccionar foto..."
                @change="setupCropper"
                :error-messages="errors"
              ></v-file-input>
            </ValidationProvider>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                text
                @click="
                  () => {
                    reset(), $emit('dialog:change', 'close');
                  }
                "
                >cancelar</v-btn
              >
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                :loading="loadingUploadPhoto"
                :disabled="!selectedFile || loadingUploadPhoto"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                rounded
                @click="passes(UpdatePhoto)"
                >Cargar</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </section>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import debounce from "lodash/debounce";

export default {
  name: "UploadImageComponent",

  props: {
    activeDialog: Boolean,
    type: String,
    id: Number,
  },

  data() {
    return {
      loadingUploadPhoto: false,
      cropper: null,
      objectUrl: null,
      previewCropped: null,
      selectedFile: null,
      debouncedUpdatePreview: debounce(this.updatePreview, 257),
    };
  },

  methods: {
    async UpdatePhoto() {
      try {
        // De base64 a tipo File
        let newFile;
        const url = this.previewCropped;
        await fetch(url)
          .then((res) => res.blob())
          .then((blob) => {
            newFile = new File([blob], "File name", { type: "image/png" });
          });

        const payload = new FormData();
        payload.append("file", newFile);
        payload.append("id", this.id);
        payload.append("message", "imagen nueva");

        this.loadingUploadPhoto = true;

        let response;

        switch (this.type) {
          case "user":
            // payload.user_id = this.id;

            response = await this.$store.dispatch("user/UPDATE_USERPHOTOPROFILE", payload);

            break;

          //   case "client":
          // payload.client_id = this.id;

          //     response = await this.$store.dispatch(
          //       "clients/UPDATE_CLIENTPHOTOPROFILE",
          //       payload
          //     );
          //     break;
        }

        // console.log(response);

        if (response.status == 200) {
          this.$snotify.success("La foto ha sido agregada con éxito.", "¡Buena elección!");
          this.loadingUploadPhoto = false;
          this.selectedFile = null;
          this.cropper = null;
          this.objectUrl = null;
          this.previewCropped = null;
          this.photoDialog = false;
          this.$emit("dialog:change", "success");
          this.$nextTick(() => {
            this.$refs.UploadUserAvatar.reset();
          });
        }
      } catch (error) {
        this.loadingUploadPhoto = false;
        console.error(error);
      }
    },

    // Crop Image
    resetCropper() {
      this.cropper.reset();
    },

    rotateLeft() {
      this.cropper.rotate(-90);
    },

    rotateRight() {
      this.cropper.rotate(90);
    },

    setupCropper(selectedFile) {
      if (this.cropper) {
        this.cropper.destroy();
      }

      if (this.objectUrl) {
        window.URL.revokeObjectURL(this.objectUrl);
      }

      if (!selectedFile) {
        this.cropper = null;
        this.objectUrl = null;
        this.previewCropped = null;
        return;
      }

      this.objectUrl = window.URL.createObjectURL(selectedFile);
      this.$nextTick(this.setupCropperInstance);
    },

    setupCropperInstance() {
      this.cropper = new Cropper(this.$refs.source, {
        aspectRatio: 1,
        crop: this.debouncedUpdatePreview,
      });
    },

    updatePreview() {
      const canvas = this.cropper.getCroppedCanvas();
      this.previewCropped = canvas.toDataURL("image/png");
    },
  },
};
</script>
